module.exports = __webpack_public_path__ + "img/circle1.1e2374e5.png";